module.exports = __webpack_public_path__ + "static/media/watermarkmain.a87829fc.png";